import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IPaginated } from 'src/app/interface/paginated';
import { IChat } from 'src/app/interface/chat';
import { IUser } from 'src/app/interface/user';
import { IGroup } from 'src/app/interface/group';
import { IPaginatedResponse } from 'src/app/interface/response';
import { IMessage } from 'src/app/interface/message';
import { AuthService } from '../auth/auth.service';

@Injectable({
	providedIn: 'root'
})
export class ChatService {

	constructor(
		private httpClient: HttpClient,
		private authService: AuthService
	) { }

	public index(page?: number): Observable<IPaginated<IChat>> {
		let params = new HttpParams();
		if (page) {
			params = params.append('page', page.toString());
		}
		if (!this.authService.company) {
			return this.httpClient.get<IPaginated<IChat>>(
				environment.apiUrl + '/chat/index', { params }
			);
		}
		return this.httpClient.get<IPaginated<IChat>>(
			environment.apiUrl + '/{current_company_id}/chat/index', { params }
		);
	}

	public unreadMessages(): Observable<IUnreadMessagesResponse> {
		if (!this.authService.company) {
			return this.httpClient.get<IUnreadMessagesResponse>(
				environment.apiUrl + '/chat/unread_messages'
			);
		}
		return this.httpClient.get<IUnreadMessagesResponse>(
			environment.apiUrl + '/{current_company_id}/chat/unread_messages'
		);
	}

	public messages(data: IMessageIndex): Observable<IMessageIndexResponse> {
		let params = new HttpParams();
		if (data.page) {
			params = params.append('page', data.page?.toString());
		}
		if (data.user_id) {
			params = params.append('user_id', data.user_id?.toString());
		}
		if (data.group_id) {
			params = params.append('group_id', data.group_id?.toString());
		}
		return this
			.httpClient
			.get<IMessageIndexResponse>(environment.apiUrl + '/{current_company_id}/message/index', { params });
	}

	public messagesRead(data: IMessagesRead): Observable<any> {
		return this.httpClient.post<any>(environment.apiUrl + '/{current_company_id}/message/read', data);
	}

	public sendMessage(data: ISendMessage): Observable<ISendMessageResponse> {
		return this.httpClient.post<any>(environment.apiUrl + '/{current_company_id}/message/store', data);
	}
}

interface IUnreadMessagesResponse {
	unread_messages?: number;
}

interface IUnreadMessagesResponse {
	unread_messages?: number;
}

interface IMessageIndex {
	page?: number;
	user_id?: number;
	group_id?: number;
}

interface IMessageIndexResponse {
	chatter?: IUser | IGroup;
	messages?: IPaginatedResponse<IMessage>;
}

interface IMessagesRead {
	user_id?: number;
	group_id?: number;
	messages?: Array<number>;
}

interface ISendMessage {
	user_id?: number;
	group_id?: number;
	message?: string;
}

interface ISendMessageResponse {
	message?: IMessage;
}
